import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class GtmManagerSvc {
  public trackEvent(eventName: string, params: Record<string, any> = {}): void {
    if (!(window as any).dataLayer) {
      (window as any).dataLayer = [];
    }
    (window as any).dataLayer.push({
      event: eventName,
      ...params
    });
  }
}
